export const name = 'platform' as const
